<template>
  <div id="IconButton">
    <section id="HomeIcon" class="HomeIcon section-bg">
      <div class="container">
        <div class="aaa" data-aos="zoom-in">
          <h1>{{ IconButtonName }}</h1>

          <ul class="iconBt" id="BtBar">
            <li
              v-for="IconButton in data.newsdata.IconButtonList"
              :key="IconButton.id"
              class="IconButton"
              @click="setIconButtonAndNowTab(IconButton.id)"
            >
              <router-link
                :to="{
                  name: 'ProductsPage',
                  params: { IconButtonId: IconButton.link },
                }"
              >
                <img class="IconImg" :src="IconButton.Image" />
                <p>{{ getIconLabel(IconButton) }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import i18n from "@/i18n";
import iconButtonLogic from "../api/IconButton.js";

export default {
  name: "IconButton",
  ...iconButtonLogic,

  computed: {
    currentLocale() {
      const locale = i18n.global.locale;
      return typeof locale === "string" ? locale : locale.value;
    },

    // IconButtonName() {
    //   return this.currentLocale === "en" ? "Categories" : "分類選單";
    // },
  },

  methods: {
    getIconLabel(iconButton) {
      return this.currentLocale === "en"
        ? iconButton.labelEn || iconButton.labelZh
        : iconButton.labelZh || iconButton.labelEn;
    },
  },
};
</script>

<style>
.iconBt {
  padding-left: 0%;
}

.IconButton {
  list-style-type: none;
}

/*--------------------------------------------------------------
      # HomeIcon
--------------------------------------------------------------*/
.HomeIcon {
  padding: 95px 0 5px 0;
  text-align: center;
  text-decoration: none;
}

.aaa {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.IconButton p {
  display: block;
  color: #404a4e;
  text-decoration: none;
  margin-bottom: 0;
  font-size: 15px;
  line-height: 1.4;
  min-height: 42px;
}

.IconImg {
  transition: all 0.4s ease-in-out;
  display: inline-block;
  margin: 10px 15px 10px 15px;
  background-color: #00489b;
  border-radius: 50%;
}

.IconImg:hover {
  transform: scale(1.1);
}

.IconButton:focus-within {
  filter: grayscale(100);
}

@media (max-width: 800px) {
  .iconBt {
    display: flex;
    flex-wrap: inherit;
    height: 140px;
    overflow-x: scroll;
  }

  .iconBt::-webkit-scrollbar-track {
    background-color: #404a4e;
    border-radius: 10px;
  }

  .iconBt::-webkit-scrollbar-thumb {
    background-color: #00489b;
  }

  .iconBt::-webkit-scrollbar {
    width: 5px;
    height: 4px;
  }
}

@media (min-width: 800px) {
  .iconBt {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 1500px) {
  .HomeIcon ul {
    width: 606px;
  }
}

@media (max-width: 400px) {
  .HomeIcon ul {
    width: 100%;
  }
}
</style>